'use strict';exports.__esModule = true;var navigationItemsIds = exports.navigationItemsIds = {
  advertisement: 'advertisement',
  address: 'address',
  aboutProperty: 'aboutProperty',
  aboutBuilding: 'aboutBuilding',
  photo: 'images',
  description: 'description',
  priceAndCondition: 'priceAndCondition',
  contacts: 'contacts',
  publish: 'publish' };


var navigationItems = function navigationItems(translate) {return [
  { id: navigationItemsIds.advertisement, name: translate('outlineNavigation', 'advertisement') },
  { id: navigationItemsIds.address, name: translate('outlineNavigation', 'address') },
  { id: navigationItemsIds.aboutProperty, name: translate('outlineNavigation', 'propertyDetails') },
  { id: navigationItemsIds.aboutBuilding, name: translate('outlineNavigation', 'building') },
  { id: navigationItemsIds.photo, name: translate('outlineNavigation', 'photo') },
  { id: navigationItemsIds.description, name: translate('outlineNavigation', 'description') },
  { id: navigationItemsIds.priceAndCondition, name: translate('outlineNavigation', 'priceAndDealDetails') },
  { id: navigationItemsIds.contacts, name: translate('outlineNavigation', 'contacts')
    // { id: navigationItemsIds.publish, name: translate('outlineNavigation', 'publish') }
  }];};

var getNavigationItems = exports.getNavigationItems = function getNavigationItems(translate) {var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var localizedItems = navigationItems(translate);
  return localizedItems.filter(function (_ref) {var id = _ref.id;return ids.includes(id);});
};

var getAllNavigationItems = exports.getAllNavigationItems = function getAllNavigationItems(translate) {return navigationItems(translate);};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PublishPropertyPage/helpers/outlineNavigationItems.js
// module id = 3063
// module chunks = 0